import React from 'react';
import { observer } from 'mobx-react';
import { CellProps } from '../../stores/card/ModeExcel';
import { Spin } from 'antd';
import PopoverTips from './PopoverTips';
// import ExcelTableColgroupTr from './ColgroupTr';
import ExcelTableCellDetailTBody from './DetailTBody';
import ExcelTableCellDetailTHead from './DetailTHead';
import CardStore from '../../stores/card';
import { WeaLocaleProvider, WeaDragula } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;
import DetailPagination from './DetailPagination';
import { getRowIndex } from '../../util/typeUtil';
import jQuery from 'jquery';
import { isDragula, calculateDetailAreaStyle } from '../../util/cubeUtil';
import DetailTop from './DetailTop';
import { modeForm_pc } from '../../util/excelUtil2';
export interface ExcelTableCellDetailTableProps {
    cell: CellProps;
    card: CardStore;
}

@observer
export default class ExcelTableCellDetailTable extends React.Component<ExcelTableCellDetailTableProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            isDetailPagePositionInit: false,
        }
    }
    dref: any = React.createRef();
    componentDidMount() {
        //处理滚动条的问题，考虑除打印布局外的情况
        const { card } = this.props;
        const contents = document.querySelectorAll('.excelDetailContent');
        const heads = document.querySelectorAll('.excelDetailFixedHead');
        if (card.base.type != "4") {
            for (let i = 0; i < contents.length; i++) {
                contents[i].addEventListener('scroll', function () {
                    heads[i].scrollLeft = contents[i].scrollLeft;
                });
            }
            //    let url=WeaTools.WindowFunc.getTop().location.href;
            jQuery(".excelDetailTable_wrap").each(function () {
                const groupid = parseInt(jQuery(this).attr("data-groupid")) || parseInt(jQuery(this).parent().attr("data-groupid"));
                let isDrag = card.modeExcel.isDragulaMap && card.modeExcel.isDragulaMap["detail_" + groupid] || false;
                const excelDetailContent = jQuery(this).find(".excelDetailContent");
                const swapWidth = excelDetailContent.width();
                const dataAreaWidth = excelDetailContent.find("#oTable" + groupid).width();
                const lockedAreaWidth = jQuery(this).parent().find("#fixArea_" + groupid) && jQuery(this).parent().find("#fixArea_" + groupid).width() || -1;
                const detailObj = { "forceDisabledLocked": false };
                if ((lockedAreaWidth > -1) && (swapWidth > 0) && (swapWidth <= lockedAreaWidth)) {      //锁定宽度过大，锁定列失效
                    detailObj["forceDisabledLocked"] = true;
                    !isDrag && modeForm_pc.showMessage(getLabel(514714, "锁定列已超出明细$s可显示宽度，锁定列失效").replace("$s", groupid + ""), 1, 1);
                } else if (swapWidth >= dataAreaWidth) {//宽度不足，横向滚动条失效
                    detailObj["forceDisabledLocked"] = true;
                }
                if (!card.modeExcel.detailMap["detail_" + groupid]) {
                    card.modeExcel.detailMap = {...card.modeExcel.detailMap, ["detail_" + groupid]: detailObj};
                }
            })
        }
        const node = this.dref;
        calculateDetailAreaStyle(jQuery(node).parent());
    }

    componentDidUpdate (){
        const that=this;
        !this.state.isDetailPagePositionInit&&jQuery(".excelDetailTable_wrap").each(function () {
            if(jQuery(this).find('.cube-detail-paging').length>0){
                let contentwidth=jQuery(this).find('.excelDetailContent').width();
                let scrollwidth=jQuery(this).find('.excelDetailContent')[0].scrollWidth;
                if(contentwidth>=scrollwidth&&contentwidth!==0){
                    jQuery(this).find(".cube-detail-paging").css('bottom','5px');
                }
                that.setState({isDetailPagePositionInit:true});
            }
        })
    }
    // componentWillUnmount() {
    //     const { card } = this.props;
    //     const contents = document.querySelectorAll('.excelDetailContent');
    //     const heads = document.querySelectorAll('.excelDetailFixedHead');
    //     if (card.base.type != "4") {
    //         for (let i = 0; i < contents.length; i++) {
    //             contents[i].removeEventListener('scroll', function () {
    //                 heads[i].scrollLeft = contents[i].scrollLeft;
    //             });
    //         }
    //     }
    // }
    // componentDidUpdate() {
    //     const { card } = this.props;
    //     const contents = document.querySelectorAll('.excelDetailContent');
    //     const heads = document.querySelectorAll('.excelDetailFixedHead');
    //     if (card.base.type != "4") {
    //         for (let i = 0; i < contents.length; i++) {
    //             contents[i].scrollLeft = heads[i].scrollLeft;
    //         }
    //     }
    // }
    hasFooter = () => {
        const { cell, card } = this.props;
        const excel = card.modeExcel.getExcel(cell.detail);
        const { edtailinrow = '0', seniorset = '0', rows = [] } = excel || {};
        let bodyRow = parseInt(edtailinrow, 0);
        let isSeniorset = seniorset == '1';
        let _rowhead = rows.slice();
        const rowIndexArr: any = [];
        _rowhead.map((row) => {
            const rowIndex: number = getRowIndex(row.id);
            rowIndexArr.push(rowIndex);
        });
        var max = Math.max.apply(null, rowIndexArr);
        if (isSeniorset && max > bodyRow) {
            return true
        }
        return false;
    }

    onDrop = (datas, dataIdx, downIdx, data) => {
        const { cell, card } = this.props;
        if (card.cubeForm.has(cell.detail)) {
            card.cubeForm.$(cell.detail).isDrag = true;
        }
        const index = cell.detail && cell.detail.replace('detail_', '');
        //修正序号
        jQuery("#oTable" + index + " tbody tr").each((item, e) => {
            jQuery(e).find('td span[class="serialNumber"] ').text((item + 1));
        })

    }

    getKeyFromData = (record, index) => {
        return index;
    };

    getKeyFromDom = (dom) => {
        const { cell, card } = this.props;
        const excel = card.modeExcel.getExcel(cell.detail);
        return excel.isHaveDetailCheck ? jQuery("span.icon-coms-move", dom).attr("data-index")
            : jQuery(dom).attr("data-rowindex");
    };

    randerTable(classNames, tableid, newWidth, excel, spinning, isNeedPagination) {
        const { cell, card } = this.props;
        const form = card.cubeForm.$(cell.detail);
        let isDrag = isDragula(card, cell.detail);
        if (isDrag) {
            return <WeaDragula ecId={`${this && this.props && this.props.ecId || ''}_WeaDragula@1acjsh`}
                container=".detailtbody"
                canDrag={(target) => {
                    return excel.isHaveDetailCheck ?
                        jQuery(target).hasClass("icon-coms-move")
                        : jQuery(target).closest("tr")
                }}
                datas={form.values()}
                getKeyFromData={this.getKeyFromData}
                getKeyFromDom={this.getKeyFromDom}
                onDrop={this.onDrop}
            >
                <table className={classNames} id={tableid} {...{ name: tableid }} style={{ minWidth: "100%", width: newWidth }} >
                    <ExcelTableCellDetailTHead ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailTHead@ehrhpj`} card={card} excel={excel} form={form} detail={cell.detail} isNeedPagination={isNeedPagination} isFixFieldDiv={false} />
                    {!spinning && <ExcelTableCellDetailTBody ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailTBody@c2ybfh`} key={form.forceRender } card={card} excel={excel} form={form} detail={cell.detail} isNeedPagination={isNeedPagination} isFixFieldDiv={false} />}
                </table>
            </WeaDragula>
        } else {
            return <table className={classNames} id={tableid} {...{ name: tableid }} style={{ minWidth: "100%", width: newWidth }} >
                <ExcelTableCellDetailTHead ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailTHead@mqwibu`} card={card} excel={excel} form={form} detail={cell.detail} isNeedPagination={isNeedPagination} isFixFieldDiv={false} />
                {!spinning && <ExcelTableCellDetailTBody ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailTBody@85m8y7`} key={form.forceRender } card={card} excel={excel} form={form} detail={cell.detail} isNeedPagination={isNeedPagination} isFixFieldDiv={false}  />}
            </table>
        }
    }


    render() {
        const { cell, card } = this.props;
        const {getDetailFormValues,} = card;
        const classNames = 'excelDetailTable';
        const wrapClassNames = 'excelDetailTable_wrap';
        const excel = card.modeExcel.getExcel(cell.detail);
        const detailMap = card.modeExcel.detailMap;
        const index = cell.detail && cell.detail.replace('detail_', '');
        const detailObj = detailMap[cell.detail];
        const tableid = `oTable${index}`;
        const spinning = !cell.detail || !card.cubeForm.has(cell.detail);
        const style: any = cell.style || {};
        const { isPagination = false } = excel.detailProps;
        const form = card.cubeForm.$(cell.detail);
        const fixFieldIndex = excel.fixFieldIndex;
        const detailVals = getDetailFormValues(form).lentgh || 0; 
        const contentstyle: any = detailVals > 0 ? { minHeight: '32px' } : {}
        const isNeedPagination = (card.base.type == '0' || card.base.type == '1' || card.base.type == '2') && isPagination;
        const newWidth = '100%';
        const supportLockedCol = excel.edlockedcol || -1;
        const forceDisabledLocked = detailObj && detailObj["forceDisabledLocked"] !== false;//列宽超过，是否强制不显示锁定列
        let isDrag = isDragula(card, cell.detail);
        return (
            <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@fvntlg`} spinning={spinning} style={{ width: '100%' }}>
                <PopoverTips ecId={`${this && this.props && this.props.ecId || ''}_PopoverTips@ux9geh`}
                    error={excel.error}
                    type="error"
                    label={`${getLabel(17463, "明细") + index}`}
                >
                    <div ref={ref => { this.dref = ref }} className="cube-detail">
                        <DetailTop ecId={`${this && this.props && this.props.ecId || ''}_DetailTop@e5aheo`} card={card} excel={excel} form={form} detail={cell.detail} isNeedPagination={isNeedPagination}  />
                        <div className="excelDetailTableDiv" id={`dTableArea_${index}`} data-groupid={index} >
                            <div className={wrapClassNames}
                                style={{
                                    width: '100%', overflowX: 'auto',msOverflowStyle: 'scrollbar',
                                    borderBottom: isNeedPagination ? style.borderLeft  || '1px solid #90badd' : 'none',
                                    paddingBottom: isNeedPagination ? "45px" : "0px"
                                }} onScroll={() => this.scrollListen(event, fixFieldIndex,)}>
                                { //打印布局走正常情况
                                    card.base.type != "4" &&
                                    <div className="excelDetailFixedHead" >
                                        <table className="excelDetailTable" id={`${tableid}_head`} style={{ minWidth: "100%", width: newWidth }}>
                                            {!spinning && <ExcelTableCellDetailTHead ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailTHead@no4v0a`} card={card} excel={excel} form={form} detail={cell.detail} isNeedPagination={isNeedPagination} isFixFieldDiv={false} />}
                                        </table>
                                    </div>
                                }
                                <div className={card.base.type != "4" ? "excelDetailContent" : ""} >
                                    {this.randerTable(classNames, tableid, newWidth, excel, spinning, isNeedPagination)}
                                    {
                                        isNeedPagination &&
                                        <DetailPagination ecId={`${this && this.props && this.props.ecId || ''}_DetailPagination@z13m88`} card={card} cell={cell} form={form} />
                                    }
                                </div>
                            </div>

                            {!forceDisabledLocked && supportLockedCol >= 0 && !isDrag && card.base.type != "4" &&

                                <div id={`fixArea_${index}`} className="excelDetailTableArea_locked"
                                    style={{ ...contentstyle, position: "absolute", left: "0", top: "0", overflow: "hidden", background: "#FFFFFF", width: excel.fixFieldWidth }}
                                >
                                    <div className="excelDetailFixedHead_locked" style={{ width: excel.fixFieldWidth }}  >
                                        <table className="excelDetailTable" id={`${tableid}_head_locked`} style={{ minWidth: "100%", width: excel.fixFieldWidth }}>
                                            {!spinning && <ExcelTableCellDetailTHead ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailTHead@s1igy8`} card={card} excel={excel} form={form} detail={cell.detail} isNeedPagination={isNeedPagination} isFixFieldDiv={true} />}
                                        </table>
                                    </div>
                                    <div className={card.base.type != "4" ? "excelDetailContent" : ""} style={{ ...contentstyle, overflow: "hidden" }}>
                                        <table className={classNames} id={`${tableid}_locked`} {...{ name: tableid }} style={{ minWidth: "100%", width: excel.fixFieldWidth }} >
                                            <ExcelTableCellDetailTHead ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailTHead@id0j66`} card={card} excel={excel} form={form} detail={cell.detail} isNeedPagination={isNeedPagination} isFixFieldDiv={true} />
                                            {!spinning && <ExcelTableCellDetailTBody ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailTBody@hv2o1n`} key={form.forceRender } card={card} excel={excel} form={form} detail={cell.detail} isNeedPagination={isNeedPagination} isFixFieldDiv={true}  />}
                                        </table>


                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </PopoverTips>
            </Spin>
        )
    }




    /**对滚动条进行监听 */
    scrollListen = (e, fixFieldIndex, ) => {
        if (fixFieldIndex == undefined || fixFieldIndex < 0) return true;
        const scroll = jQuery(e.target).scrollLeft();
        if (scroll == 0) {
            //    jQuery(jQuery(e.target).parent().find("#fixField")).css({ "box-shadow": "none", "-webkit-box-shadow": "none" });
            jQuery(jQuery(e.target).parent().find(".excelDetailTableArea_locked")).css({ borderRight: "0px solid", "box-shadow": "none" });
        } else {
            jQuery(jQuery(e.target).parent().find(".excelDetailTableArea_locked")).css({  "box-shadow": "6px 0 6px hsla(0,0%,39%,0.2)" });
        }
    }


}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/DetailTable.tsx